import React from "react";
//import ReactDOM from 'react-dom';
import axios from 'axios';
import './Megamenu.css';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
class Megamenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menu : [],
            no : '13'
        

        }
        
    };
    componentDidMount(){
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/method/ecom.api.get_item_group_Byroute?route='+this.props.groups), {
            headers : {'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({menu:response.data['message']})
        //console.log(response.data['data'])
        })

    }  
    render() {
        return<div className="mega-menu-wrap menu-background-image" style={{
            backgroundImage: `url(${process.env.REACT_APP_API_URL
                +this.props.img } )`

          }}>
            
            <div className="menu-contianer">
         {this.state.menu.map((itm,k)=>{
        return(
                                        <div className="sub-menu" key={k}>
                                            <a href={"/"+itm.route}>
                                                <span>{itm.name}</span>
                                            </a>
                                            <div className="submenu-item">
                                            {

                                            itm.subs.map((item,j)=>{
                                                //this.setState({la:j})
                                                //this.setState({le:j})
                                               //let no='13'
                                                if(j < this.state.no){
                                                   // this.setState({le:'13'})
                                                    return(
                                                        <div className="sub-sub-menu "  key={j} ><a href={"/"+item.route}><ArrowForwardIosIcon className="sub-menu-arrow m-1"/>{item.name}</a>
                                                   
                                                        </div>
                                                    )
                                                }
                                                else{
                                                    return("")
                                                }
                                               
                                            })}
                                             {itm.subs.length > this.state.no ?  <p className="view-all"><a href={"/"+itm.route}>View All</a></p> :'' } 

                                            </div>
                                        </div>
                                        
                                        )
})}
    </div>
   {/*  <div className="menu-img dpdn-connected-img">
        <img src={process.env.REACT_APP_API_URL + this.props.img}  alt="img"/>
    </div> */}
    </div>
       }
    }
    export default Megamenu;